import { create } from "zustand";
import type { ConfirmTone } from "../components/confirm-dialog";

interface IdefaultValues {
  id: number | string;
  onClick: () => void;
  title?: string;
  /** What actually happens, and whether it can be undone. */
  description?: string;
  /** Verb on the confirm button — "Archive", "Cancel plan" — never "Submit". */
  confirmLabel?: string;
  tone?: ConfirmTone;
}

const defaultValues: IdefaultValues = {
  id: "",
  onClick: () => {},
  title: "",
  description: "",
  confirmLabel: "",
  tone: "primary",
};

interface IuseSuretyModel {
  onOpenSuretyPopup: (values: IdefaultValues) => void;
  onCloseSuretyPopup: () => void;
  initialValues: IdefaultValues;
}

export const useSuretyModel = create<IuseSuretyModel>((set) => ({
  initialValues: defaultValues,
  onOpenSuretyPopup: ({
    id,
    onClick,
    title,
    description,
    confirmLabel,
    tone,
  }: IdefaultValues) =>
    set({
      initialValues: { id, onClick, title, description, confirmLabel, tone },
    }),
  onCloseSuretyPopup: () =>
    set({
      initialValues: defaultValues,
    }),
}));
